import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import {
  BookmarkBorder as BookmarkIcon,
  ChevronRight as ChevronRightIcon,
} from '@mui/icons-material';

/**
 * "Pick up where you left off" (design: CardStoreApp.dc.html vRevised, under the invitation band).
 *
 * A returning visitor with unfinished designs currently has to know "My creations" exists in the
 * header. This puts the count and the way back in the reading path, directly beneath the invitation
 * that would otherwise ask them to start over. Renders nothing when there is nothing saved.
 */
const SavedDesignsRow = ({ count = 0 }) => {
  if (!count) return null;

  return (
    <Box
      component={RouterLink}
      to="/creations"
      data-testid="saved-designs-row"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        backgroundColor: '#f3f7f8',
        border: '1px solid #dceaee',
        borderRadius: '10px',
        p: '12px 14px',
        mt: 1.75,
        textDecoration: 'none',
        '&:hover': { backgroundColor: '#eaf2f4' },
      }}
    >
      <BookmarkIcon aria-hidden sx={{ fontSize: 22, color: '#206884' }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ fontSize: '0.9rem', fontWeight: 600, color: '#206884', lineHeight: 1.3 }}>
          You have {count} saved design{count === 1 ? '' : 's'}
        </Box>
        <Box sx={{ fontSize: '0.8rem', color: '#526065' }}>Pick up where you left off</Box>
      </Box>
      <ChevronRightIcon aria-hidden sx={{ fontSize: 22, color: '#9db3ba' }} />
    </Box>
  );
};

export default SavedDesignsRow;
